module.exports = __webpack_public_path__ + "img/grid.27c86a1a.svg";